import React from "react";
import { BrowserRouter } from "react-router-dom";
import { Routes, Route, Link } from "react-router-dom";
import Login from "./pages/Login";
// import Dashboard from "./pages/Dashboard";
import { PrivateRoutes } from "@/routes";
// import HSN from "./pages/HSN";
// import LedgerList from "./pages/LedgerList";
// import AreaMaster from "./pages/AreaMaster";
export default function App() {
  return (
    <>
      <BrowserRouter basename={process.env.PUBLIC_URL}>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route element={<PrivateRoutes />}>
            {/* <Route path="/dashboard" element={<Dashboard />} /> */}
            {/* <Route path="/hsn" element={<HSN />} /> */}
            {/* <Route path="/ledgerList" element={<LedgerList />} /> */}
            {/* <Route path="/areamaster" element={<AreaMaster />} /> */}
          </Route>
        </Routes>
      </BrowserRouter>
    </>
  );
}
